import { Component, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
  selector: 'app-document-signer-notifications',
  templateUrl: './document-signer-notifications.component.html',
  styles: [],
})
export class DocumentSignerNotificationsComponent {
  @Input() form: FormGroup
}
